import 'bootstrap/dist/css/bootstrap.min.css'
import React, { Component, useContext, useEffect, useState } from 'react'
import { Button, Col, Container, Form, InputGroup, Nav, Navbar, Row } from 'react-bootstrap'
import * as Icon from 'react-bootstrap-icons'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import CommonDialog from './common/CommonDialog'
import { BottomNavigation, BottomNavigationAction, useMediaQuery, useTheme } from '@mui/material'
import AITalk from './AITalk'
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import HomeIcon from '@mui/icons-material/Home';
import FavoriteIcon2 from '@mui/icons-material/Favorite';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MediaSelectDialog from './generate/MediaSelectDialog'
import { LoginInfo } from '../App'

const Footer = (props) => {
    const theme = useTheme()
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))
    const location = useLocation()
    const isHome = location.pathname === '/';

    const {t,i18n} = useTranslation()
    const navigate = useNavigate()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    const [showFooterMenu,setShowFooterMenu] = useState(true)
    const [openGeneratePanel,setOpenGeneratePanel] = useState(false)
    const [aIAssistant,setAIAssistant] = useState(false)
    const [fullScreen,setFullScreen] = useState(false)
    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    function isSmartPhone() {
        if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
            return true;
        } else {
            return false;
        }
    }

    let params = useLocation()
    useEffect(() => {
        if(params.pathname === "/upload/image/generate" || params.pathname === "/generate/image/simple" || params.pathname.indexOf("/aitalk") !== -1){
            setShowFooterMenu(false)
        }
        if(isSmartPhone()){
            setFullScreen(true)
        }
    },[params])

    const footerBottomPadding = showFooterMenu ? '110px' : '40px'
    const footerContainerStyle = {
        position: 'relative',
        backgroundColor: '#555555',
        color: '#FFFFFF',
        paddingBottom: footerBottomPadding,
        marginBottom: 0,
        marginTop: 'auto'
    }

    return (
        <>
        <MediaSelectDialog
            open={openGeneratePanel}
            onClose={() => setOpenGeneratePanel(false)}
            onSelectSimpleImage={() => navigate("/generate/image/simple")}
            onSelectImage={() => navigate("/upload/image/generate")}
            onSelectAudio={() => navigate("/generate/voice")}
        />
        <CommonDialog open={aIAssistant} onClose={() => setAIAssistant(false)} content={<AITalk show={true} dialog={dialog} setPoint={() => {}} setAIAssistant={setAIAssistant} />} fullScreen={fullScreen} />
        <div style={{position:"fixed",bottom:0,zIndex:8,width:isLargeScreen && isHome ? window.innerWidth - 280 : "100%",margin:"0 auto",display:showFooterMenu ? "block" : "none"}}>
            <BottomNavigation
            style={{width:"100%"}}
            showLabels
            //value={value}
            onChange={(event, newValue) => {
                //setValue(newValue);
            }}
            >
            <BottomNavigationAction label="生成" icon={<AutoFixHighIcon />} onClick={() => setOpenGeneratePanel(true)} />
            <BottomNavigationAction label={t("category.home")} icon={<HomeIcon />} href='/' />
            <BottomNavigationAction label="AIチャット" icon={<SmartToyIcon />} onClick={() => navigate("/aitalk")/*setAIAssistant(true)*/} />
            <BottomNavigationAction label={t("common.like")} icon={<FavoriteIcon2 />} onClick={() => navigate("/favorite")} />
            {loginInfo.result && false ? <BottomNavigationAction label={"振り返り"} icon={<CalendarMonthIcon />} onClick={() => navigate("/user/" + (loginInfo.userId) +"/best/2024")} /> : ""}
            </BottomNavigation>
        </div>
        <div className='text-center mt-3' style={footerContainerStyle}>
            <Container>
                <Container className='mb-3'>
                    「アワートAI」はAIを活用した作品の投稿サイトです。<br />
                    生成機能も搭載。<br />
                </Container>
                <Row>
                    <Col>
                        <Link to="/" className="App-logo white" style={{fontSize:"24px"}} onClick={() => window.scrollTo({top:0,left:0,behavior:"instant"})}><img src='/img/logo_new_footer.png' height={36} /></Link><br />
                        <Link to={"/company"} className='white' onClick={() => window.scrollTo({top:0,left:0,behavior:"instant"})}>運営会社</Link><br />
                        <a className='white' href="https://twitter.com/ourt_ai" target="_blank" rel="noreferrer">公式X(Twitter)</a><br />
                    </Col>
                    <Col>
                        <Link to="/terms" className='white'>利用規約</Link><br />
                        <Link to="/guideline" className='white'>ガイドライン</Link><br />
                        <Link to="/privacy" className='white'>個人情報保護方針</Link><br />
                        <Link to="/legal" className='white'>特商法表記</Link>
                    </Col>
                    <Col>
                        <Link to={"/"} className='white' onClick={() => window.scrollTo({top:0,left:0,behavior:"instant"})}>ホーム</Link><br />
                        <Link to={"/new"} className='white' onClick={() => window.scrollTo({top:0,left:0,behavior:"instant"})}>新着</Link><br />
                        <Link to={"/ranking/illustration/general/1day/s_all/1"} onClick={() => window.scrollTo({top:0,left:0,behavior:"instant"})} className='white'>ランキング</Link><br />
                        <Link to={"/odai"} className='white'onClick={() => window.scrollTo({top:0,left:0,behavior:"instant"})} >お題一覧</Link><br />
                    </Col>
                    <Col>
                        <Link to={"/search/*/1"} className='white' onClick={() => window.scrollTo({top:0,left:0,behavior:"instant"})}>イラスト検索</Link><br />
                        <Link to={"/tag/*/1"} className='white' onClick={() => window.scrollTo({top:0,left:0,behavior:"instant"})}>タグ検索</Link><br />
                        <Link to={"/random"} className='white' onClick={() => window.scrollTo({top:0,left:0,behavior:"instant"})}>作品を発見</Link><br />
                        <Link to={"/status"} className='white' onClick={() => window.scrollTo({top:0,left:0,behavior:"instant"})}>ステータス</Link><br />
                    </Col>
                </Row>
                <Row className='mt-4'>
                    <Col className='d-flex flex-column align-items-center justify-content-center'>
                        <div style={{fontWeight:"bold", fontSize: "14px"}}>スマホアプリ版</div>
                        <a
                            href="https://play.google.com/store/apps/details?id=work.ourt_ai.mobile"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Google Play で入手"
                            className='mt-2'
                            style={{display:"inline-block"}}
                        >
                            <img
                                src="/img/GetItOnGooglePlay_Badge_Web_color_Japanese.png"
                                alt="Google Play で手に入れよう"
                                style={{width:"180px", maxWidth:"60vw", height:"auto"}}
                                loading='lazy'
                            />
                        </a>
                        {/* iOS 対応予定の場合のプレースホルダー */}
                        {/* <div style={{fontSize:"12px", marginTop:"4px", opacity:0.7}}>iOS版近日公開</div> */}
                    </Col>
                </Row>
            </Container>
        </div>
        </>
    )
}

export default Footer;